import React from 'react';
import PropTypes from 'prop-types';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Pagination, Navigation } from 'swiper';
import { getRegion } from 'utils/Region';
import {
  DEFAULT_BREAKPOINTS,
  DEFAULT_PLACEHOLDER_PIC,
  BREAKPOINTS_SEARCHER,
} from './constants/talentCarouselConstants';
//----------------------------------------------------------------------------------------
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import { TalentCard } from './components/TalentCard';
import 'swiper/swiper-bundle.min.css';
import 'swiper/swiper.min.css';
import './style.scss';
import { useSelector } from 'react-redux';

// ESTE COMPONENTE TE RENDERIZA EL CARRUSEL DE TALENTOS, EL PARAMETRO BREAKPOINTCONFIG HACE REFERENCIA
// AL RESPONSIVE DE CUANTOS SILIDES SE DEBEN MOSTRAR SEGUN LA RESOLUCIÒN
SwiperCore.use([Pagination, Navigation]);
const TalentsCarousel = ({
  title,
  talents,
  onTalentClick,
  breakpointConfig = DEFAULT_BREAKPOINTS,
}) => {
  const {
    playingLive_player_general_icon_backChannel: prev,
    playingLive_player_general_icon_nextChannel: next,
    content_data_talent_placeholder,
  } = useSelector(state => state.asset);
  const placeholderTalent =
    content_data_talent_placeholder || DEFAULT_PLACEHOLDER_PIC;
  const isSearcher = window.location?.pathname?.includes('search');
  return (
    <div className="talents-carousel">
      <div className="talents-carousel__header">
        <h2 className="talents-carousel__header__title">{title}</h2>
        <div className="talents-carousel__header__navigation">
          <img
            className="talents-carousel__header__navigation__prev-btn"
            src={prev}
            alt="back"
          />
          <img
            className="talents-carousel__header__navigation__next-btn"
            src={next}
            alt="next"
          />
        </div>
      </div>
      <Swiper
        breakpoints={isSearcher ? BREAKPOINTS_SEARCHER : breakpointConfig}
        className="mySwiper swiper-slide-scroll"
        navigation={{
          prevEl: '.talents-carousel__header__navigation__prev-btn',
          nextEl: '.talents-carousel__header__navigation__next-btn',
        }}
        spaceBetween={24}
        slidesPerView={1}
        style={{ marginTop: 24 }}
        watchOverflow
      >
        {talents?.map((talent,i) => (
          <SwiperSlide key={`talent-key-${talent?.id}-${i}`}>
            <TalentCard
              talentId={talent?.id}
              imageUrl={talent?.image ? talent?.image : DEFAULT_PLACEHOLDER_PIC}
              talentName={`${talent?.first_name} ${
                talent?.last_name !== null ? talent?.last_name : ''
              }`}
              talentRole={talent.type}
              onClick={() => onTalentClick(talent.id, talent.internalId)}
            />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

TalentsCarousel.propTypes = {
  talents: PropTypes.array.isRequired,
  onTalentClick: PropTypes.func.isRequired,
  breakpointConfig: PropTypes.object,
};

export default TalentsCarousel;
